module.exports = __webpack_public_path__ + "img/bb-logo-background.621f3247.svg";